import { render, staticRenderFns } from "./question-card.vue?vue&type=template&id=ee6ef4a0&scoped=true"
import script from "./question-card.vue?vue&type=script&lang=ts"
export * from "./question-card.vue?vue&type=script&lang=ts"
import style0 from "./question-card.vue?vue&type=style&index=0&id=ee6ef4a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6ef4a0",
  null
  
)

export default component.exports